import { DepositComponent } from "./orderpage/item/deposit/deposit.component";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { SharedModule } from "projects/sepidz-web-framework-shell/src/lib/shared/shared.module";
import { SepidzGridModule } from "projects/sepidz-web-framework-data-grid/src/lib/grid.module";
import { OrderPageComponent } from "./orderpage/orderpage.component";
import { ItemComponent } from "./orderpage/item/desktop/item.component";
import { FastAccessComponent } from "./orderpage/fastaccess/fastaccess.component";
import { OrderHeaderComponent } from "./orderpage/header/orderheader.component";
import { CustomerFastAccessComponent } from "./orderpage/fastaccess/customerfastaccess/customerfastaccess.component";
import { SalonFastAccessComponent } from "./orderpage/fastaccess/salonfastaccess/salonfastaccess.component";
import { CustomerOrderComponent } from "./customerorder/customerorder.component";
import { CustomerAddressOrderComponent } from "./customerorder/customeraddressorder/customeraddressorder.component";
import { CustomerNumberOrderComponent } from "./customerorder/customernumberorder/customernumberorder.component";
import { DescriptionComponent } from "./orderpage/item/description/description.component";
import { InvoicesComponent } from "./invoices/invoices.component";
import { PagerFastAccessComponent } from "./orderpage/fastaccess/pagerfastaccess/pagerfastaccess.component";
import { DriverAssignmentFastAccessComponent } from "./orderpage/fastaccess/driverassignmentfastaccess/driverassignmentfastaccess.component";
import { WaiterFastAccessComponent } from "./orderpage/fastaccess/waiterfastaccess/waiterfastaccess.component";
import { InvoiceChangeFastAccess } from "./orderpage/fastaccess/invoicechangefastaccess/invoicechangefastaccess.component";
import { TotalPriceComponent } from "./orderpage/invoice/totalprice/totalprice.component";
import { NewCustomerOrderComponent } from "./customerorder/newcustomerorder/newcustomerorder.component";
import { CustomerDetailsOrderComponent } from "./customerorder/customerdetailsorder/customerdetailsorder.component";
import { ThemeModule } from "projects/sepidz-web-framework-shell/src/lib/@theme/theme.module";
import { PaymentComponent } from "./orderpage/invoice/payment/payment.component";
import { SalonOrderComponent } from "./salonorder/desktop/salonorder.component";
import { OrderFooterComponent } from "./orderpage/footer/orderfooter.component";
import { OrderInvoiceComponent } from "./orderpage/invoice/desktop/invoice.component";
import { AddressPhoneFormComponent } from "./orderpage/fastaccess/address-phone-form/address-phone-form.component";
import { SimpleMenuComponent } from "./orderpage/item/desktop/contextment";
import { ClubFastAccessComponent } from "./orderpage/fastaccess/clubfastaccess/orderclubfastacces.component";
import { OrderonlineComponent } from "./orderonline/orderonline.component";
import { CausecancelComponent } from "./orderonline/causecancel/causecancel.component";
import { SuccessOrderComponent } from "./orderonline/success-order/success-order.component";
import { CallSupportComponent } from "./orderonline/call-support/call-support.component";
import { ClubConfirmationComponent } from "./orderpage/fastaccess/clubfastaccess/clubconfirmation/clubconfirmation.component";
import { DriverAssignmentModule } from "../driverassignment/driverassignment.module";
import { PaymentLinkFastAccessComponent } from "./orderpage/fastaccess/PaymentLinkFastAcceess/paymentlinkfastaccess.component";
import { DateDialogComponent } from "../dateDialog/dateDialog.component";
import { CustomerPrintTemplateFormComponent } from "./orderpage/invoice/customer-print-template-form/customer-print-template-form/customer-print-template-form.component";
import { TabletPosService } from "./providers/tabletpos.service";
import { DelinoOfflineFactorcomponent } from "./orderpage/fastaccess/delinoOfflineFactor/delinoofflinefactor.component";
import { PreparationDeliveryTimeFormComponent } from "./orderpage/invoice/preparation-delivery-time-form/preparation-delivery-time-form.component";
import { DeliveredComponent } from "./delivered/delivered.component";
import { DepositMenuComponent } from "./orderpage/item/deposit/deposit-menu.component";
import { DepositSelectShowHideComponent } from "./orderpage/item/deposit/deposit-select-show-hide/deposit-select-show-hide.component";
import { ReserveOnlineComponent } from "./reserve-online/reserve-online.component";
import { FormatTimeFromBackendPipe } from "./delivered/format-time-from-backend.pipe";
import { ReserveOnlineSettingComponent } from "./reserve-online/reserve-online-setting/reserve-online-setting.component";
import { ReserveOnlineSettingMenuComponent } from "./reserve-online/reserve-online-setting/reserve-online-setting-menu.component";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { PosScaleService } from "./providers/pos-scale.service";

const components = [
  CustomerAddressOrderComponent,
  CustomerNumberOrderComponent,
  CustomerOrderComponent,
  SalonOrderComponent,
  OrderPageComponent,
  OrderHeaderComponent,
  FastAccessComponent,
  ItemComponent,
  DescriptionComponent,
  TotalPriceComponent,
  CustomerPrintTemplateFormComponent,
  SalonFastAccessComponent,
  DriverAssignmentFastAccessComponent,
  CustomerFastAccessComponent,
  InvoicesComponent,
  PagerFastAccessComponent,
  WaiterFastAccessComponent,
  InvoiceChangeFastAccess,
  CustomerAddressOrderComponent,
  NewCustomerOrderComponent,
  CustomerDetailsOrderComponent,
  PaymentComponent,
  OrderFooterComponent,
  OrderInvoiceComponent,
  AddressPhoneFormComponent,
  SimpleMenuComponent,
  ClubFastAccessComponent,
  OrderonlineComponent,
  CausecancelComponent,
  SuccessOrderComponent,
  CallSupportComponent,
  ClubConfirmationComponent,
  PaymentLinkFastAccessComponent,
  DateDialogComponent,
  PreparationDeliveryTimeFormComponent,
  DelinoOfflineFactorcomponent,
  DepositComponent,
  DeliveredComponent,
  DepositMenuComponent,
  DepositSelectShowHideComponent,
  PreparationDeliveryTimeFormComponent,
  ReserveOnlineComponent,
  FormatTimeFromBackendPipe,
  ReserveOnlineSettingComponent,
  ReserveOnlineSettingMenuComponent,
];
@NgModule({
  declarations: [...components],
  exports: [...components],
  imports: [CommonModule, FormsModule, SharedModule.forRoot(), SepidzGridModule, ThemeModule, DriverAssignmentModule, ScrollingModule],
  providers: [TabletPosService, PosScaleService],
})
export class OrderModule {}
